import React, { memo } from "react";
import { Dialog } from "@mui/material";
import { CustomDialogProps } from "./types";

const CustomDialog = memo((props: CustomDialogProps) => {
  return <Dialog {...props} />;
});

export { CustomDialog };
